<template>
  <input-dropdown :options="mappedTanks" :value="tankId" @change="handleInput"/>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import InputDropdown from "../../input/Dropdown";

export default {
  name: 'TankDropdown',

  components: {
    InputDropdown
  },

  computed: {
    ...mapState({
      tankId: state => state.build.tank,
    }),
    ...mapGetters({
      tanks: 'tanks/getTanks',
      best: 'build/getBestTank',
      availableTanks: 'tanks/getAvailableTanks'
    }),

    mappedTanks() {
      return this.availableTanks
          .map(tank => {
            return {
              key: tank.id,
              value: this.translate(tank.name),
              recommended: this.best === tank.id,
            }
          });
    }
  },

  methods: {
    handleInput(id) {
      this.$store.dispatch('build/setTank', id);
      this.$store.dispatch('openFrameOptions/reset', []);
    }
  }
}
</script>
